var map = {
	"./Dots.svg": 60057,
	"./Illustration-Error.svg": 91810,
	"./MicPermissionsDialogImage.svg": 68189,
	"./PlayIcon.svg": 53272,
	"./addhero.16.svg": 99249,
	"./fonts/Bahnschrift.woff": 90624,
	"./icon-16.png": 73265,
	"./icon-32.png": 88995,
	"./icon-80.png": 65700,
	"./logo-filled.png": 81218,
	"./ping_image.png": 55676,
	"./transcription_signal_indicator.png": 12579
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34215;